module.exports = __webpack_public_path__ + "img/feature-title.6f38e2cd.png";